import React, { useState, useEffect } from 'react';
import './SrishtiModal.css';

const amenities = [
  { icon: '🌳', num: '01', text: 'Parks & Green Spaces' },
  { icon: '🔐', num: '02', text: 'Security Guard' },
  { icon: '📞', num: '03', text: 'Intercom Facility' },
  { icon: '⚡', num: '04', text: 'Power Backup' },
  { icon: '🛕', num: '05', text: 'Temple Inside Complex' },
  { icon: '📷', num: '06', text: 'CCTV Surveillance' },
  { icon: '🏪', num: '07', text: 'Commercial Club & Shops' },
  { icon: '🚗', num: '08', text: 'Dedicated Parking' },
  { icon: '🛣️', num: '09', text: '22ft Wide Internal Roads' },
  { icon: '🌿', num: '10', text: 'Landscaped Boundary' },
  { icon: '🏫', num: '11', text: 'School in 1 Km Radius' },
  { icon: '🏥', num: '12', text: 'Nursing Home Nearby' },
];

const floorPlans = [
  {
    type: '100 Sq. Yd.',
    config: '3 BHK',
    color: '#C0176B',
    floors: ['Ground Floor', 'First Floor'],
    groundRooms: [
      { name: 'Bedroom', size: "12'4.5\" × 14'0\"", bg: '#FCE4EC' },
      { name: 'Toilet', size: "7'8\" × 7'3\"", bg: '#E8EAF6' },
      { name: 'Kitchen', size: "15'4\" × 14'10.5\"", bg: '#E3F2FD' },
      { name: 'Drawing/Dining', size: "10'10.5\" × 13'7.5\"", bg: '#FFF3E0' },
      { name: 'Parking', size: "9'0\" × 14'0\"", bg: '#ECEFF1' },
      { name: 'Rear Open', size: "3'4.5\" Wide", bg: '#F1F8E9' },
    ],
    firstRooms: [
      { name: 'Bedroom', size: "12'4.5\" × 14'0\"", bg: '#FCE4EC' },
      { name: 'Master Bedroom', size: "14'10.5\" × 11'7.5\"", bg: '#F8BBD0' },
      { name: 'F. Lobby', size: "15'4\" × 14'10.5\"", bg: '#FFF3E0' },
      { name: 'Toilet', size: "7'8\" × 7'3\"", bg: '#E8EAF6' },
      { name: 'Dress', size: "5'0\" × 5'3\"", bg: '#F3E5F5' },
      { name: 'Balcony', size: "5'0\" Wide", bg: '#E8F5E9' },
    ],
  },
  {
    type: '91 Sq. Yd.',
    config: '2 BHK',
    color: '#8B17C0',
    floors: ['Ground Floor', 'First Floor'],
    groundRooms: [
      { name: 'Bedroom', size: "12'4.5\" × 14'0\"", bg: '#F3E5F5' },
      { name: 'Toilet', size: "7'6\" × 10'7.5\"", bg: '#E8EAF6' },
      { name: 'Kitchen', size: "15'4\" × 14'10.5\"", bg: '#E3F2FD' },
      { name: 'Drg/Dining', size: "10'10.5\" × 13'7.5\"", bg: '#FFF3E0' },
      { name: 'Parking', size: "9'0\" × 14'0\"", bg: '#ECEFF1' },
      { name: 'Rear Open', size: "3'4.5\" Wide", bg: '#F1F8E9' },
    ],
    firstRooms: [
      { name: 'Bedroom', size: "12'4.5\" × 14'0\"", bg: '#F3E5F5' },
      { name: 'Master Bedroom', size: "14'10.5\" × 11'7.5\"", bg: '#E1BEE7' },
      { name: 'Lobby', size: "15'4\" × 14'10.5\"", bg: '#FFF3E0' },
      { name: 'Toilet', size: "7'6\" × 10'7.5\"", bg: '#E8EAF6' },
      { name: 'Dress', size: "5'0\" × 5'3\"", bg: '#F3E5F5' },
      { name: 'Balcony', size: "5'0\" Wide", bg: '#E8F5E9' },
    ],
  },
  {
    type: '72 Sq. Yd.',
    config: '2 BHK',
    color: '#C06017',
    floors: ['Ground Floor'],
    groundRooms: [
      { name: 'Bed Room', size: "10'0\" × 12'0\"", bg: '#FFF3E0' },
      { name: 'Bed Room', size: "12'6\" × 10'3\"", bg: '#FFF3E0' },
      { name: 'Kitchen', size: "10'0\" × 5'0\"", bg: '#E3F2FD' },
      { name: 'Drawing/Dining', size: "12'3\" × 12'0\"", bg: '#FCE4EC' },
      { name: 'Toilet 1', size: "7'3\" × 5'0\"", bg: '#E8EAF6' },
      { name: 'Toilet 2', size: "5'6\" × 5'0\"", bg: '#E8EAF6' },
    ],
    firstRooms: [],
  },
];

const locationPoints = [
  { dist: '1.5 Km', place: 'Crossing Republic, NH-24' },
  { dist: '1 Km', place: 'Proposed Metro Noida Extension' },
  { dist: '1 Km', place: 'SKS World School, Wisdom Tree & BLS World School' },
  { dist: '1 Km', place: 'Authority 20 Acres Park' },
  { dist: '1.5 Km', place: 'ABES Engineering College, NH-24' },
  { dist: '4 Km', place: 'Vijay Nagar Railway Station, Ghaziabad' },
  { dist: '5 Km', place: 'Noida, Sector-121' },
  { dist: '6.5 Km', place: 'Indirapuram, Ghaziabad' },
  { dist: '7 Km', place: 'Noida, Sector-71' },
  { dist: '8.5 Km', place: 'Sai Mandir' },
  { dist: '10 Km', place: 'Noida City Centre Metro Station' },
];

const tabs = ['Overview', 'Amenities', 'Floor Plans', 'Location', 'Contact'];

export default function SrishtiModal({ onClose }) {
  const [activeTab, setActiveTab] = useState('Overview');
  const [activePlan, setActivePlan] = useState(0);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div className="sr-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="sr-modal">

        {/* ── HERO ── */}
        <div className="sr-hero">
          <img src="/image/ShrishtiHeights.webp" alt="Aalayam Srishti Villas" className="sr-hero-img" />
          <div className="sr-hero-overlay" />
          <button className="sr-close" onClick={onClose} aria-label="Close">
            <i className="fa fa-times" />
          </button>
          <div className="sr-hero-content">
            <div className="sr-badge">Paradise Group Presents</div>
            <h1>Aalayam Srishti Villas</h1>
            <p className="sr-tagline">Premium Villas · Sec 16, Chipyana Bujurg, Greater Noida West – 201009</p>
            <div className="sr-hero-tags">
              <span><i className="fa fa-check-circle" /> 2 & 3 BHK Villas</span>
              <span><i className="fa fa-map-marker-alt" /> Greater Noida West</span>
              <span><i className="fa fa-building" /> Commercial Club</span>
              <span><i className="fa fa-road" /> 22ft Wide Roads</span>
            </div>
          </div>
        </div>

        {/* ── TABS ── */}
        <div className="sr-tabs">
          {tabs.map(tab => (
            <button
              key={tab}
              className={`sr-tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* ── BODY ── */}
        <div className="sr-body">

          {/* OVERVIEW */}
          {activeTab === 'Overview' && (
            <div className="sr-section">
              <div className="sr-overview-grid">
                <div className="sr-overview-text">
                  <div className="sr-pink-tag">आलायम — Aalayam Srishti Villas</div>
                  <h2>Modern Living Meets Smart Design</h2>
                  <p>
                    <strong>Aalayam Srishti Villas</strong> by Paradise Group is a thoughtfully planned
                    residential community offering 2 BHK and 3 BHK premium villas in the heart of
                    Greater Noida West.
                  </p>
                  <p>
                    With over <strong>139+ premium plots</strong>, wide internal roads, a Commercial Club
                    with shops, parks, and a dedicated temple — this is a self-sufficient township
                    designed for modern families.
                  </p>
                  <p>
                    Each villa is designed for <strong>superior ventilation, Vastu compliance</strong>,
                    and spectacular landscape views, ensuring your family lives in comfort and style.
                  </p>
                  <div className="sr-highlights">
                    <div className="sr-hl-item">
                      <span className="sr-hl-num">139+</span>
                      <span className="sr-hl-label">Premium Plots</span>
                    </div>
                    <div className="sr-hl-item">
                      <span className="sr-hl-num">2&3</span>
                      <span className="sr-hl-label">BHK Options</span>
                    </div>
                    <div className="sr-hl-item">
                      <span className="sr-hl-num">72–100</span>
                      <span className="sr-hl-label">Sq. Yd. Sizes</span>
                    </div>
                    <div className="sr-hl-item">
                      <span className="sr-hl-num">22ft</span>
                      <span className="sr-hl-label">Wide Roads</span>
                    </div>
                  </div>
                </div>
                <div className="sr-overview-img">
                  <img src="/image/ShrishtiHeights.webp" alt="Srishti Villas" />
                  <div className="sr-img-tag">✨ Aalayam Srishti Villas</div>
                </div>
              </div>

              {/* Commercial Club highlight */}
              <div className="sr-club-section">
                <div className="sr-club-icon">🏢</div>
                <div>
                  <h3>Commercial Club Inside Township</h3>
                  <p>
                    A fully equipped <strong>Commercial Club</strong> with retail shops on the ground
                    floor and club facilities above — giving residents everything they need within
                    walking distance. From groceries to entertainment, it's all here.
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* AMENITIES */}
          {activeTab === 'Amenities' && (
            <div className="sr-section">
              <h2>World-Class Amenities</h2>
              <p className="sr-section-sub">12 premium amenities for a complete lifestyle experience</p>
              <div className="sr-amenities-grid">
                {amenities.map((a, i) => (
                  <div className="sr-amenity-card" key={i}>
                    <div className="sr-num-badge">{a.num}</div>
                    <div className="sr-amenity-icon">{a.icon}</div>
                    <span>{a.text}</span>
                  </div>
                ))}
              </div>

              <div className="sr-brands-section">
                <h3>Quality Products Used</h3>
                <div className="sr-brands">
                  {['Hindware', 'JK Wall Putty', 'Crompton Greaves', 'UltraTech Cement', 'Somany', 'Asian Paints', 'Havells', 'Stelmax Steel'].map(b => (
                    <div className="sr-brand-chip" key={b}>{b}</div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* FLOOR PLANS */}
          {activeTab === 'Floor Plans' && (
            <div className="sr-section">
              <h2>Layout Plans</h2>
              <p className="sr-section-sub">3 plot sizes — choose the perfect fit for your family</p>

              <div className="sr-plan-tabs">
                {floorPlans.map((plan, i) => (
                  <button
                    key={i}
                    className={`sr-plan-tab ${activePlan === i ? 'active' : ''}`}
                    style={activePlan === i ? { background: plan.color, borderColor: plan.color } : {}}
                    onClick={() => setActivePlan(i)}
                  >
                    {plan.config} — {plan.type}
                  </button>
                ))}
              </div>

              <div className="sr-plan-content">
                <div className="sr-plan-info" style={{ borderTop: `4px solid ${floorPlans[activePlan].color}` }}>
                  <div className="sr-plan-header">
                    <h3>{floorPlans[activePlan].config} Villa</h3>
                    <span className="sr-plan-badge" style={{ background: floorPlans[activePlan].color }}>
                      {floorPlans[activePlan].type}
                    </span>
                  </div>
                  <div className="sr-plan-floors-chips">
                    {floorPlans[activePlan].floors.map((f, i) => (
                      <div className="sr-floor-chip" key={i}
                        style={{ background: floorPlans[activePlan].color + '18', color: floorPlans[activePlan].color, border: `1.5px solid ${floorPlans[activePlan].color}40` }}>
                        {f}
                      </div>
                    ))}
                  </div>
                  <div className="sr-room-list">
                    <div className="sr-room-section-label">Ground Floor</div>
                    {floorPlans[activePlan].groundRooms.map((r, i) => (
                      <div className="sr-room-row" key={i}>
                        <span className="sr-room-dot" style={{ background: floorPlans[activePlan].color }} />
                        <span className="sr-room-name">{r.name}</span>
                        <span className="sr-room-size">{r.size}</span>
                      </div>
                    ))}
                    {floorPlans[activePlan].firstRooms.length > 0 && (
                      <>
                        <div className="sr-room-section-label" style={{ marginTop: 12 }}>First Floor</div>
                        {floorPlans[activePlan].firstRooms.map((r, i) => (
                          <div className="sr-room-row" key={i}>
                            <span className="sr-room-dot" style={{ background: floorPlans[activePlan].color }} />
                            <span className="sr-room-name">{r.name}</span>
                            <span className="sr-room-size">{r.size}</span>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                  <button className="sr-enquire-btn" style={{ background: floorPlans[activePlan].color }}>
                    <i className="fa fa-phone" /> Enquire About This Plan
                  </button>
                </div>

                <div className="sr-plan-visual">
                  <div className="sr-floor-diagram">
                    <div className="sr-floor-label">Ground Floor Layout</div>
                    <div className="sr-floor-rooms">
                      {floorPlans[activePlan].groundRooms.map((r, i) => (
                        <div className="sr-room" key={i} style={{ background: r.bg }}>
                          {r.name}<br /><small>{r.size}</small>
                        </div>
                      ))}
                    </div>
                    {floorPlans[activePlan].firstRooms.length > 0 && (
                      <>
                        <div className="sr-floor-label" style={{ marginTop: 14 }}>First Floor Layout</div>
                        <div className="sr-floor-rooms">
                          {floorPlans[activePlan].firstRooms.map((r, i) => (
                            <div className="sr-room" key={i} style={{ background: r.bg }}>
                              {r.name}<br /><small>{r.size}</small>
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* LOCATION */}
          {activeTab === 'Location' && (
            <div className="sr-section">
              <h2>Excellent Connectivity</h2>
              <p className="sr-section-sub">Sec 16, Chipyana Bujurg, Greater Noida West — surrounded by top schools, hospitals & malls</p>

              <div className="sr-location-grid">
                <div className="sr-loc-list">
                  <h3><i className="fa fa-map-marker-alt" /> Distance Advantage</h3>
                  {locationPoints.map((l, i) => (
                    <div className="sr-loc-item" key={i}>
                      <div className="sr-loc-dist">{l.dist}</div>
                      <div className="sr-loc-place">{l.place}</div>
                    </div>
                  ))}
                </div>

                <div className="sr-nearby">
                  <div className="sr-nearby-group">
                    <h3><i className="fa fa-graduation-cap" /> Schools Nearby</h3>
                    <ul>
                      <li>SKS World School (1 Km)</li>
                      <li>Wisdom Tree School (1 Km)</li>
                      <li>BLS World School (1 Km)</li>
                      <li>ABES Engineering College (1.5 Km)</li>
                    </ul>
                  </div>
                  <div className="sr-nearby-group">
                    <h3><i className="fa fa-shopping-bag" /> Nearby Facilities</h3>
                    <ul>
                      <li>Shopping Complexes</li>
                      <li>Nursery Schools</li>
                      <li>Religious Places</li>
                      <li>Petrol Pump</li>
                    </ul>
                  </div>
                  <div className="sr-nearby-group">
                    <h3><i className="fa fa-hospital" /> Healthcare</h3>
                    <ul>
                      <li>Nursing Homes in Vicinity</li>
                      <li>Authority 20 Acres Park (1 Km)</li>
                      <li>Upcoming Metro Station (1 Km)</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="sr-map-box">
                <iframe
                  title="Srishti Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.1!2d77.4501!3d28.638!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce5a43173357b%3A0x37ffce30c87cc03f!2sGreater%20Noida%20West!5e0!3m2!1sen!2sin!4v1699999999"
                  width="100%" height="200"
                  style={{ border: 0, borderRadius: 12 }}
                  allowFullScreen="" loading="lazy"
                />
              </div>
            </div>
          )}

          {/* CONTACT */}
          {activeTab === 'Contact' && (
            <div className="sr-section">
              <h2>Get In Touch</h2>
              <p className="sr-section-sub">Book a site visit or get more information about Aalayam Srishti Villas</p>

              <div className="sr-contact-grid">
                <div className="sr-contact-card">
                  <div className="sr-contact-icon" style={{ background: '#FCE4EC' }}>
                    <i className="fa fa-building" style={{ color: '#C0176B' }} />
                  </div>
                  <div>
                    <h4>Corporate Office</h4>
                    <p><strong>Aalayam Srishti Villas</strong><br />
                    Sec 16, Behind SKS World School,<br />
                    Chipyana Bujurg, Greater Noida West,<br />
                    Greater Noida – 201009</p>
                  </div>
                </div>
                <div className="sr-contact-card">
                  <div className="sr-contact-icon" style={{ background: '#F3E5F5' }}>
                    <i className="fa fa-envelope" style={{ color: '#8B17C0' }} />
                  </div>
                  <div>
                    <h4>Email Us</h4>
                    <p>info@paradisegroupncr.com</p>
                  </div>
                </div>
                <div className="sr-contact-card">
                  <div className="sr-contact-icon" style={{ background: '#FCE4EC' }}>
                    <i className="fa fa-globe" style={{ color: '#C0176B' }} />
                  </div>
                  <div>
                    <h4>Website</h4>
                    <p>www.paradisegroupncr.com</p>
                  </div>
                </div>
                <div className="sr-contact-card">
                  <div className="sr-contact-icon" style={{ background: '#F3E5F5' }}>
                    <i className="fa fa-phone" style={{ color: '#8B17C0' }} />
                  </div>
                  <div>
                    <h4>Call Us</h4>
                    <p>+91 94149-53399</p>
                  </div>
                </div>
              </div>

              <button className="sr-visit-btn">
                <i className="fa fa-calendar-check" /> Book a Free Site Visit
              </button>

              <div className="sr-disclaimer">
                <strong>Disclaimer:</strong> This brochure, floor plans and any marketing material does not
                form part of any contract. All layouts, plans, specifications, dimensions and designs are
                indicative only of an architect's impression. Subject to change as decided by the company
                or competent authority. *T&C Apply.
              </div>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
